export { default } from './StockTabsPanel';
